export default __webpack_public_path__ + "static/media/s2_male.dbd92595.wav";